import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { HeaderComponent } from "../../header/header.component";
import { FooterComponent } from "../../footer/footer.component";
import { RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-system-admin-dashboard',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent, RouterOutlet, RouterLink, RouterModule],
  templateUrl: './system-admin-dashboard.component.html',
  styleUrl: './system-admin-dashboard.component.scss'
})
export class SystemAdminDashboardComponent{
 
}
